import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { UtilsModule } from '../utils/utils.module';

import { ProgressButtonModule } from '@syncfusion/ej2-angular-splitbuttons';
import { LoadingModule } from '../shared/loading/loading.module';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TextBoxModule,
    UtilsModule,
    ProgressButtonModule,
    LoadingModule
  ],
  exports: []
})
export class AuthModule { }
